export default function NumericInputLabel({labelName,inputName,defaultValue,onChangeFn}){
  return(
    <>
      <label>{labelName}</label>
      <input type='number' defaultValue={defaultValue} name={inputName} onChange={onChangeFn} step='0.1'/>
    </>
  )
}